import { defineFieldFormInterface } from "~/entities/field";
import FileSingleType from "./FileSingleType.vue";

export default defineFieldFormInterface({
  type: "uuid",
  interface: "file",
  component: FileSingleType,
});
